// extracted by mini-css-extract-plugin
export default {"avatar":"SignUp_avatar__hataf"};